export class HomeMessageDto {
  constructor(public message: string) {}
}
